import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import sitesReducer from './sitesSlice';
import builderReducer from './builderSlice';
import handlingSlice from './handlingSlice';
import usersReducer from './usersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sites: sitesReducer,
    builder: builderReducer,
    handling: handlingSlice,
    users: usersReducer,
  },
});
